module.exports = __webpack_public_path__ + "static/media/star.e155764f.png";